"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stroToBtoa = void 0;
const stroToBtoa = (str) => {
    return typeof btoa === 'undefined' ? Buffer.from(str).toString('base64') : btoa(str);
};
exports.stroToBtoa = stroToBtoa;
